import React from "react";
import { Col, Container, Row, Image } from "react-bootstrap";
import { Footer } from "./Footer";
import { HeroAlt } from "./HeroAlt";
import Navigation from "./Navigation";

export const GalleryPage = () => {
  return (
    <div>
      <header>
        <Navigation />
        <HeroAlt
          title="Gallery"
          pageDescription="This page will allow you to showcase your work by providing images of previous works you are proud of."
        />
      </header>
      <main>
        <Container fluid as="section" className="gallery-page">
          <Container className=" d-flex flex-column justify-content-center">
            <Row>
              <Col sm="12" md="12" lg="4">
                <figure data-aos="fade-right">
                  <Image
                    fluid
                    src="https://via.placeholder.com/500x500"
                    alt="Placeholder image"
                  ></Image>
                  <figcaption>Image Description</figcaption>
                </figure>
              </Col>
              <Col sm="12" md="12" lg="4">
                <figure data-aos="fade-up">
                  <Image
                    fluid
                    src="https://via.placeholder.com/500x500"
                    alt="Placeholder image"
                  ></Image>
                  <figcaption>Image Description</figcaption>
                </figure>
              </Col>
              <Col sm="12" md="12" lg="4">
                <figure data-aos="fade-left">
                  <Image
                    fluid
                    src="https://via.placeholder.com/500x500"
                    alt="Placeholder image"
                  ></Image>
                  <figcaption>Image Description</figcaption>
                </figure>
              </Col>
            </Row>
            <Row>
              <Col sm="12" md="12" lg="4">
                <figure data-aos="fade-right">
                  <Image
                    fluid
                    src="https://via.placeholder.com/500x500"
                    alt="Placeholder image"
                  ></Image>
                  <figcaption>Image Description</figcaption>
                </figure>
              </Col>
              <Col sm="12" md="12" lg="4">
                <figure data-aos="fade-up">
                  <Image
                    fluid
                    src="https://via.placeholder.com/500x500"
                    alt="Placeholder image"
                  ></Image>
                  <figcaption>Image Description</figcaption>
                </figure>
              </Col>
              <Col sm="12" md="12" lg="4">
                <figure data-aos="fade-left">
                  <Image
                    fluid
                    src="https://via.placeholder.com/500x500"
                    alt="Placeholder image"
                  ></Image>
                  <figcaption>Image Description</figcaption>
                </figure>
              </Col>
            </Row>
            <Row>
              <Col sm="12" md="12" lg="4">
                <figure data-aos="fade-right">
                  <Image
                    fluid
                    src="https://via.placeholder.com/500x500"
                    alt="Placeholder image"
                  ></Image>
                  <figcaption>Image Description</figcaption>
                </figure>
              </Col>
              <Col sm="12" md="12" lg="4">
                <figure data-aos="fade-up">
                  <Image
                    fluid
                    src="https://via.placeholder.com/500x500"
                    alt="Placeholder image"
                  ></Image>
                  <figcaption>Image Description</figcaption>
                </figure>
              </Col>
              <Col sm="12" md="12" lg="4">
                <figure data-aos="fade-left">
                  <Image
                    fluid
                    src="https://via.placeholder.com/500x500"
                    alt="Placeholder image"
                  ></Image>
                  <figcaption>Image Description</figcaption>
                </figure>
              </Col>
            </Row>
          </Container>
        </Container>
      </main>
      <footer>
        <Footer />
      </footer>
    </div>
  );
};
